import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import "./header.css";

const Header = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="w-100 header-container d-flex">
      {props.children && (
        <div
          onClick={() => {
            if (location.pathname === "/reservationmenu" ||location.pathname === "/welcome" ) {
              navigate("/main");
            }
            else if (window.history.length <= 1) navigate("/main");
            else navigate(-1);
          }}
          className="header-image-container"
        >
          {props.children}
        </div>
      )}

      <div className="h1 header-text-container" style={{ color: "#00867F" }}>
        <b>{props.title}</b>
      </div>
    </div>
  );
};

export default Header;
